import React from "react";
import Navigation from "./components/common/navigation/Navigation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

const App = () => {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Navigation />
        </BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
      </QueryClientProvider>
    </>
  );
};

export default App;
